import { Box } from "@mui/material";
import { FunctionComponent as F } from "react";
import { timestampToSeconds } from "../../utils/string";
import { IValue } from "../Refs/RefsTable";
import SpielsTable from "../Refs/SpielsTable";



interface IProps
{
  record: IValue
}

const Youtube: F<IProps> = (props: IProps) =>
{
  const embedId = props.record.url.split("?v=")[1];

  const timestampUrl = (timestamp: string) => props.record.url + "&t=" + timestampToSeconds(timestamp);

  const onTimestampClick = (timestamp: string) =>
    window.open(timestampUrl(timestamp), '_blank', 'noopener,noreferrer');

  return (
    <Box sx={{ display: 'flex' }}>
      <Box sx={{ display: 'flex' }}>
        <SpielsTable
          record={props.record}
          onTimestampClick={onTimestampClick}
          timestampTooltip={timestampUrl}/>
      </Box>
      <Box sx={{ display: 'flex', textAlign: 'right' }}>
        <iframe
          width='420'
          height='236'
          src={`https://www.youtube.com/embed/${embedId}` +
            "?start=" + timestampToSeconds(props.record.startTime) /*+
            (props.endTimestamp ? "&end=" + endSeconds : "")*/}
          frameBorder='0'
          allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
          allowFullScreen
          title='Embedded youtube' />
      </Box>
    </Box>);
};

export default Youtube;
